/* SpectraPure product.js — variant picker, gallery, quantity, sticky buy box.
 * Reads window.productData (set in product-main.liquid) for variant info.
 */
(function () {
  'use strict';
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));

  const root = $('[data-product-root]');
  if (!root || !window.productData) return;

  const productData = window.productData;
  const variants = productData.variants || [];
  const optionsCount = productData.options ? productData.options.length : 0;

  /* ---------- Variant picker ---------- */
  function getSelectedOptions() {
    return $$('[data-variant-option]', root).map(group => {
      const sel = group.querySelector('[aria-checked="true"]');
      return sel ? sel.getAttribute('data-value') : null;
    });
  }

  function findVariant(opts) {
    return variants.find(v => {
      for (let i = 0; i < opts.length; i++) {
        if (v.options[i] !== opts[i]) return false;
      }
      return true;
    });
  }

  function updateVariant() {
    const opts = getSelectedOptions();
    if (opts.some(o => o === null)) return;
    const variant = findVariant(opts);
    const idInput = $('[data-variant-id]', root);
    const priceEl = $('[data-product-price]', root);
    const skuEl = $('[data-product-sku]', root);
    const stockEl = $('[data-product-stock]', root);
    const submitBtn = $('[data-product-submit]', root);

    if (!variant) {
      if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Unavailable'; }
      return;
    }
    if (idInput) idInput.value = variant.id;
    if (priceEl) priceEl.textContent = formatMoney(variant.price);
    if (skuEl) skuEl.textContent = variant.sku ? `SKU ${variant.sku}` : '';
    if (stockEl) {
      stockEl.classList.remove('c-stock--in', 'c-stock--out');
      if (variant.available) {
        stockEl.classList.add('c-stock--in');
        stockEl.querySelector('[data-stock-label]').textContent = 'In stock — ships in 1–2 business days';
      } else {
        stockEl.classList.add('c-stock--out');
        stockEl.querySelector('[data-stock-label]').textContent = 'Out of stock';
      }
    }
    if (submitBtn) {
      submitBtn.disabled = !variant.available;
      submitBtn.textContent = variant.available ? (submitBtn.dataset.labelDefault || 'Add to cart') : 'Sold out';
    }

    // featured image swap
    if (variant.featured_image && variant.featured_image.src) {
      const mainImg = $('[data-product-main-image]', root);
      if (mainImg) mainImg.src = variant.featured_image.src;
    }

    // Update URL
    if (history.replaceState) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url.toString());
    }
  }

  $$('[data-variant-option]', root).forEach(group => {
    $$('button[data-value]', group).forEach(btn => {
      btn.addEventListener('click', () => {
        $$('button[data-value]', group).forEach(b => b.setAttribute('aria-checked', 'false'));
        btn.setAttribute('aria-checked', 'true');
        updateVariant();
      });
    });
  });

  /* ---------- Gallery ---------- */
  $$('[data-thumb]', root).forEach(thumb => {
    thumb.addEventListener('click', () => {
      const src = thumb.getAttribute('data-thumb');
      const main = $('[data-product-main-image]', root);
      if (main && src) {
        main.src = src;
        main.srcset = '';
      }
      $$('[data-thumb]', root).forEach(t => t.setAttribute('aria-current', 'false'));
      thumb.setAttribute('aria-current', 'true');
    });
  });

  /* ---------- Quantity ---------- */
  $$('[data-qty-root]', root).forEach(qtyRoot => {
    const input = qtyRoot.querySelector('input');
    const dec = qtyRoot.querySelector('[data-qty-dec]');
    const inc = qtyRoot.querySelector('[data-qty-inc]');
    if (!input) return;
    if (dec) dec.addEventListener('click', () => {
      const v = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      input.value = v;
    });
    if (inc) inc.addEventListener('click', () => {
      const v = (parseInt(input.value, 10) || 1) + 1;
      input.value = v;
    });
  });

  function formatMoney(cents) {
    if (window.SpectraFormatMoney) return window.SpectraFormatMoney(cents);
    return `$${(cents / 100).toFixed(2)}`;
  }
})();

/* ---------- Bundle / FBT ---------- */
(function () {
  const root = document.querySelector('[data-bundle-root]');
  if (!root) return;
  const totalEl = root.querySelector('[data-bundle-total]');
  const items = Array.from(root.querySelectorAll('[data-bundle-item]'));
  const addBtn = root.querySelector('[data-bundle-add]');

  function fmt(cents) {
    if (window.SpectraFormatMoney) return window.SpectraFormatMoney(cents);
    return '$' + (cents / 100).toFixed(2);
  }

  function recalc() {
    const total = items.reduce((sum, el) => sum + (el.checked ? parseInt(el.dataset.price, 10) || 0 : 0), 0);
    if (totalEl) totalEl.textContent = fmt(total);
  }
  items.forEach(el => el.addEventListener('change', recalc));
  recalc();

  async function addBundle(variantIds) {
    if (!variantIds.length) return;
    const items = variantIds.map(id => ({ id: id, quantity: 1 }));
    try {
      const res = await fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items })
      });
      if (res.ok) {
        // Open cart drawer if present, else go to cart page.
        if (window.SpectraOpenCart) window.SpectraOpenCart();
        else window.location.href = window.routes.cart_url;
      }
    } catch (e) { console.error('Bundle add failed', e); }
  }
  window.SpectraAddBundle = addBundle;

  if (addBtn) {
    addBtn.addEventListener('click', () => {
      const ids = items.filter(el => el.checked && !el.disabled).map(el => el.value);
      // Always include the current product (disabled checked input)
      const required = items.filter(el => el.disabled && el.checked).map(el => el.value);
      addBundle(required.concat(ids.filter(id => !required.includes(id))));
    });
  }
})();

/* ---------- Sticky mobile ATB ---------- */
(function () {
  const bar = document.querySelector('[data-sticky-atb]');
  const mainBtn = document.querySelector('[data-product-submit]');
  if (!bar || !mainBtn) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const visible = !entry.isIntersecting;
      bar.setAttribute('data-visible', visible ? 'true' : 'false');
      bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
    });
  }, { rootMargin: '-80px 0px 0px 0px', threshold: 0 });
  observer.observe(mainBtn);

  const addBtn = bar.querySelector('[data-sticky-add]');
  if (addBtn) {
    addBtn.addEventListener('click', () => {
      // Programmatically click main submit so existing form-handler logic runs.
      mainBtn.click();
    });
  }
})();

/* ---------- Click-to-play install video ---------- */
(function () {
  document.querySelectorAll('[data-install-video]').forEach(wrap => {
    const btn = wrap.querySelector('[data-install-play]');
    if (!btn) return;
    btn.addEventListener('click', () => {
      const embed = wrap.getAttribute('data-embed');
      if (!embed) return;
      const iframe = document.createElement('iframe');
      iframe.src = embed;
      iframe.title = 'Install video';
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
      iframe.allowFullscreen = true;
      iframe.loading = 'lazy';
      wrap.innerHTML = '';
      wrap.appendChild(iframe);
    });
  });
})();
